export default {
	platformType() {
		var userAgent = navigator.userAgent.toLowerCase();
		if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(userAgent)) {
			//跳转移动端页面
			return "mobile"
		} else {
			//跳转pc端页面
			return "pc"
		}
	}
}
